import * as React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';

type Props = {
    name: string;
};

const StyFolderContainer = styled(Box, { name: 'StyFolderContainer' })(
    ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        color: theme.palette.common.white,
        backgroundColor: theme.palette.success.main,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1, 0.5),
        width: '100px',
    }),
);

const StyTypography = styled(Typography)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

//TODO : For now, we only have public folders, but we might have private folders in the future
// and we will need to change the color and icon of the folder accordingly
export const GenericCardFolderIcon = ({ name }: Props) => (
    <StyFolderContainer>
        <FolderSharedOutlinedIcon />
        <Tooltip title={name} enterDelay={500}>
            <StyTypography>{name}</StyTypography>
        </Tooltip>
    </StyFolderContainer>
);
